import { defineComponent as _defineComponent } from 'vue'
import Header from "@/components/sgre/Header.vue";
import Footer from "@/components/sgre/Footer.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();

const toSearchGrade = () => {
  router.push("/SearchGrade");
};

const __returned__ = { router, toSearchGrade, Header, Footer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})